import collapseActions from '../actions/collapse.actions';

const authenticationReducer = (state, action) => {
  switch (action.type) {
    case collapseActions.CONTACTS_COLLAPSE_SUCCESS:
      return Object.assign({}, { ...state }, { contacts: !state.contacts });
    case collapseActions.CONTACTS_SHOW_ALL_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        { contactsAll: !state.contactsAll },
      );
    case collapseActions.ADDRESSES_COLLAPSE_SUCCESS:
      return Object.assign({}, { ...state }, { addresses: !state.addresses });
    case collapseActions.ADDRESSES_SHOW_ALL_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        { addressesAll: !state.addressesAll },
      );
    case collapseActions.ASSIGNMENTS_COLLAPSE_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        { assignments: !state.assignments },
      );
    case collapseActions.UNDERWRITING_COLLAPSE_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        { underwriting: !state.underwriting },
      );
    default:
      return state;
  }
};

export default authenticationReducer;
